var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTvRetro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 96L299.2 96l79.17-67.86c6.719-5.75 7.5-15.84 1.75-22.55c-5.781-6.734-15.88-7.469-22.56-1.734L256 90.92L154.4 3.859c-6.656-5.734-16.75-5-22.56 1.734C126.1 12.3 126.9 22.39 133.6 28.14L212.8 96L64 96c-35.35 0-64 28.65-64 63.1v287.1C0 483.3 28.65 512 64 512h384c35.35 0 64-28.65 64-63.1V160C512 124.7 483.3 96 448 96zM480 448c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V160c0-17.64 14.36-32 32-32h384c17.64 0 32 14.36 32 32V448zM320.1 160L128.1 160c-35.35 0-64 28.65-64 64v160c0 35.35 28.65 64 64 64l191.1 .0002c35.35 0 64.01-28.65 64.01-64V224C384.1 188.7 355.4 160 320.1 160zM352 384c0 17.64-14.36 32-32 32H128c-17.64 0-32-14.36-32-32V224c0-17.64 14.36-32 32-32h192c17.64 0 32 14.36 32 32V384zM432 184c-13.25 0-24 10.74-24 24c0 13.25 10.75 24 24 24c13.26 0 24-10.75 24-24C456 194.7 445.3 184 432 184zM432 248c-13.25 0-24 10.74-24 24c0 13.25 10.75 24 24 24c13.26 0 24-10.75 24-24C456 258.7 445.3 248 432 248z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvRetro);
export default __webpack_public_path__ + "static/media/tv-retro.ba4a1fc30db92a8144360ea741ac937e.svg";
export { ForwardRef as ReactComponent };